// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum DetectionZoneCardinalDirection {
	North = 0,
	NorthEast = 45,
	East = 90,
	SouthEast = 135,
	South = 180,
	SouthWest = 225,
	West = 270,
	NorthWest = 315,
	Custom = -1,
}

export const DetectionZoneCardinalDirectionDisplayNames: { [key in keyof typeof DetectionZoneCardinalDirection]?: string} = {
	"North": "North",
	0 : "North",
	"NorthEast": "North East",
	45 : "North East",
	"East": "East",
	90 : "East",
	"SouthEast": "South East",
	135 : "South East",
	"South": "South",
	180 : "South",
	"SouthWest": "South West",
	225 : "South West",
	"West": "West",
	270 : "West",
	"NorthWest": "North West",
	315 : "North West",
	"Custom": "Custom",
	[-1] : "Custom",
}

export const getDetectionZoneCardinalDirectionDisplayName = (key: DetectionZoneCardinalDirection | (keyof typeof DetectionZoneCardinalDirection & string)) => {
	return DetectionZoneCardinalDirectionDisplayNames[key];
}

